import {
  createActionCreator,
  sleep,
  paramsEncode,
  arrParamsEncode,
  dateConversion,
  timeConversion,
  normalArrParamsEncode
} from '../../../utils';
import constant from './constant';
import Urls from '../../../../config';
import request from '../../../utils/request';
import { message } from 'antd';
import {actions} from "../../sign/taskNotes/reducers";
const getListUrl = Urls.TaskUrl.list;
const getTaskIdUrl = Urls.TaskUrl.getTaskId;
const submitTaskUrl = Urls.TaskUrl.submit;
const insertTaskUrl = Urls.TaskUrl.insert;
const bulkUpdateUrl = Urls.TaskUrl.bulkUpdate;
const operaTaskUrl = Urls.TaskUrl.opera;
const getProvinceUrl = Urls.TaskUrl.province;
const getClusterUrl = Urls.TaskUrl.cluster;
const getOutTaskCategoryUrl = Urls.TaskUrl.outTaskCategory;
const resetPvUrl = Urls.TaskUrl.restTargetPv;
const getPvUrl = Urls.TaskUrl.getTargetPv;
const bunchOnoffTaskUrl = Urls.TaskUrl.bunchOnoffTask;
const pasteSubTasksUrl = Urls.TaskUrl.pasteSubTask;
const getGroupsList = Urls.UserUrl.groups;
const scriptUrl = Urls.scriptUrl
const partnerUrl = Urls.PartnerUrl;
const getLabelUrl = Urls.TaskUrl.label;
const getMonitorListUrl = Urls.TaskUrl.monitroList;
const getCurvelUrl = Urls.TaskUrl.curve;
const getApi = Urls.TaskUrl.getApi;
const getTasklogsUrl = Urls.TaskUrl.getTasklogs;
const getTaskNoteUrl = Urls.TaskUrl.getTaskNote;
const getTasklogByIndexUrl = Urls.TaskUrl.getTasklogByIndex;
const getAccountListUrl = Urls.TaskUrl.getAccountList;
export const createTaskNote = createActionCreator(constant.TASKNOTE,data => data);
export const createHideTaskNoteModel = createActionCreator(constant.HIDETASKNOTE,obj => obj);
export const createShowTaskNoteModel = createActionCreator(constant.SHOWTASKNOTE,obj => obj);
export const createTasklogs = createActionCreator(constant.TASKLOGS, data => data);
export const createShowModal = createActionCreator(constant.SHOWMODAL, obj => obj);
export const createHideModal = createActionCreator(constant.HIDEMODAL, obj => obj);
export const createShowDetail = createActionCreator(constant.SHOWDETAIL, data => data);
export const  createHideDetail = createActionCreator(constant.HIDEDETAIL, data => data);
export const createTasklogByIndex = createActionCreator(constant.TASKLOGBYINDEX, data => data);

export const createLoadingAction = createActionCreator(constant.LISTLOADING, loading => loading); //修改列表loading
export const createListAction = createActionCreator(constant.TASKLISTGET, list => list); //获取列表
export const createProvinceListAction = createActionCreator(constant.PROVINCELINST, list => list); //获取省份列表
export const createLabelListAction = createActionCreator(constant.LABELLINST, list => list); //获取标签列表
export const createMonitorListAction = createActionCreator(constant.MONITERNAMELIST,list => list);
export const createCurveListAction = createActionCreator(constant.CURVELINST, list => list); //获取曲线列表
export const createClusterListAction = createActionCreator(constant.CLUSTERLINST, list => list); //获取列表GROUPLIST
export const createOutTaskCategoryListAction = createActionCreator(constant.OUTTASKCATEGORYLIST, list => list); //获取外部任务分类LIST
export const createGroupListAction = createActionCreator(constant.GROUPLIST, list => list); //获取列表
export const createGetTaskIdAction = createActionCreator(constant.GETTASKID, id => id); //获取新增id
export const createParentIdAction = createActionCreator(constant.GETPARENTID, id => id); //存parentid
export const createRootAction = createActionCreator(constant.GETROOT, parmas => parmas); //存ROOT
export const createTaskAction = createActionCreator(constant.GETTASK, parmas => parmas); //存task
export const createScreenShowAction = createActionCreator(constant.SCREENSHOTSHOW, isShowScreen => isShowScreen);//存截屏弹框展示的状态
export const createApiAction = createActionCreator(constant.SHOWAPI, obj => obj);
export const createPrintTaskItemData = createActionCreator(constant.PRINTTASKITEMDATA, parmas => parmas); //存储当前截图项人数数据{}

export const createEditInfoAction = createActionCreator(constant.EDITINFO, parmas => parmas); //点击修改对应的信息
export const createEditTimeAction = createActionCreator(constant.EDITIME, parmas => parmas); //点击修改对应的时间
export const createEditIpReusedTimesAction = createActionCreator(constant.EDITIPREUSEDTIMES, parmas => parmas); //点击修改对应的利用次数
export const createEditTaskTypeAction = createActionCreator(constant.EDITTASKTYPE, parmas => parmas); //点击修改对应的任务类型
export const createEditAndroidRatioAction = createActionCreator(constant.EDITANDROIDRATIO, parmas => parmas); //点击修改对应的安卓比例
export const createEditEngineAction = createActionCreator(constant.EDITENGINE, parmas => parmas); //点击修改对应的引擎
export const createEditTimePairsAction = createActionCreator(constant.TIMEPAIRS, parmas => parmas); //点击修改对应的执行时间段
export const createEditWaitTimeoutAction = createActionCreator(constant.EDITWAITTIMEOUT, parmas => parmas); //点击修改对应的等待时长
export const createEditPvToUvRatioAction = createActionCreator(constant.EDITPVTOUVRATIO, parmas => parmas); //点击修改对应的Uv占比
export const createEditForceWaitAction = createActionCreator(constant.EDITFORCEWAIT, parmas => parmas); //点击修改强制等待时长
export const createEditOverflowRateAction = createActionCreator(constant.EDITOVERFLOW, parmas => parmas); //点击修改溢出量
export const createEditProvinceAction = createActionCreator(constant.EDITPROVINCE, parmas => parmas); //点击修改溢出量
export const createEditTaskSource = createActionCreator(constant.TASKSOURCE, parmas => parmas); //点击修改任务来源
export const createEditTrackDelayTime = createActionCreator(constant.TRACKDELAYTIME, parmas => parmas); //任务追踪结束时间
export const createEditTaskPosition = createActionCreator(constant.TASKPOSITION, parmas => parmas); //点击修改任务位置
export const createEditMainScriptAction = createActionCreator(constant.MAINSCRIPT, parmas => parmas); //点击修改任务位置
export const createEditScriptAction = createActionCreator(constant.SCRIPT, parmas => parmas); //点击修改任务位置

export const createUserListAction = createActionCreator(constant.USERLIST, parmas => parmas); //保存用户列表

export const createPageAction = createActionCreator(constant.PAGETOTAL, page => page); //存储总页数
export const createAddShowAction = createActionCreator(constant.ADDSHOW, status => status); //修改新增弹窗状态
export const createEditShowAction = createActionCreator(constant.EDITSHOW, status => status); //修改编辑弹窗状态
export const createResetPvShowAction = createActionCreator(constant.RESETPVSHOW, status => status); //重置目标量弹窗
export const createAddTypeAction = createActionCreator(constant.ADDTYPE, type => type); //存储添加状态 1任务2子任务
export const createGetPvAction = createActionCreator(constant.GETPV, num => num); //获取任务目标量
export const createSetTaskIdAction = createActionCreator(constant.TASKID, num => num);//设置taskid
export const createSetTaskIdListAction = createActionCreator(constant.TASKIDLIST, list => list);//设置taskidList
export const createbulkUpdateShowTaskAction = createActionCreator(constant.BULKUPDATETASK, status => status); //重置目标量弹窗

export const createPrimaryScriptAction = createActionCreator(constant.PRIMRYSCRIPT, list => list);
export const createOtherScriptAction = createActionCreator(constant.OTHERSCRIPT, list => list);

export const createAgentsAction = createActionCreator(constant.AGENTS, list => list);
export const createAreasAction = createActionCreator(constant.AREAS, list => list);

export const changeEditInfo = createActionCreator(constant.CHANGE, data => data);
export const editTaskOverflowStatus = createActionCreator(constant.TASKOVERFLOWSTATU, data => data);
export const editTaskOverflowLoading = createActionCreator(constant.TASKOVERFLODINGSTATU, data => data);
export const getAccountListAction = createActionCreator(constant.ACCOUNTLIST,data => data);

export const getAccountList = () => {
  return async (dispatch, getState) => {
    try {
      let accountList = await request(getAccountListUrl, 'post');
      dispatch(getAccountListAction(accountList));
    } catch (e) {
      throw new Error(e);
    }
  }
}
export const ayncSetTaskOverFlow = contents => {
  return async (dispatch, getState) => {
    try {
      dispatch(editTaskOverflowLoading(true));
      await request(Urls.taskNotesUrl.setOverflow, 'POST', contents);
      message.success('整单编辑成功');
    } catch (e) {
      //message.error('设置随机溢出失败！');
      throw e;
    } finally {
      dispatch(editTaskOverflowLoading(false));
    }
  };
};
export const asynctaskNoteAdd = contents => {
  return async (dispatch, getState) => {
    try {
      //dispatch(actions.changeUiStatus({ isLoading: true }));
      // 下面的请求和结果返回需要根据接口来实现
      await request(Urls.taskNotesUrl.addTaskNotes, 'POST', contents);
      message.success('添加任务备注成功');
     // dispatch(actions.changeUiStatus({ isUpdateShow: false }));
    } catch (e) {
      message.error('添加任务备注失败！');
      throw e;
    } finally {
    //  dispatch(actions.changeUiStatus({ isLoading: false }));
    }
  };
};

export const asyncTaskNoteUpdate = contents => {
  return async (dispatch, getState) => {
    try {
     // dispatch(actions.changeUiStatus({ isLoading: true }));
      // 下面的请求和结果返回需要根据接口来实现
      await request(Urls.taskNotesUrl.editTaskNotes, 'POST', contents);
      message.success('修改任务备注成功');
    //  dispatch(actions.changeUiStatus({ isUpdateShow: false }));
    } catch (e) {
      message.error('修改任务备注失败！');
      throw e;
    } finally {
      //dispatch(actions.changeUiStatus({ isLoading: false }));
    }
  };
};


export const getTaskNotes = eId => {
  return async (dispatch, getState) => {
    try {
      let data = await request(getTaskNoteUrl, 'post', eId);
      if(data==null||data==undefined){
        data=eId;
      }
      dispatch(createTaskNote(data));
      dispatch(createShowTaskNoteModel(true));
    } catch (e) {
      throw new Error(e);
    }
  }
}
export const hideTaskNoteModal = () =>{
  return (dispatch, getState) => {
    dispatch(createHideTaskNoteModel(false));
  }
}

export const hideModal = () => {
    return (dispatch, getState) => {
        dispatch(createHideModal(false));
    }
}

export const getTasklogs = taskId => {
    return async (dispatch, getState) => {
        try {
            let data = await request(getTasklogsUrl, 'post', taskId);
            dispatch(createTasklogs(data));
            dispatch(createShowModal(true));
        } catch (e) {
            throw new Error(e);
        }
    }
}
export const getTasklogByIndex = (data) => {
    return async (dispatch, getState) => {
        try {
            let taskByIndex = await request(getTasklogByIndexUrl, 'post', data);
            dispatch(createTasklogByIndex(taskByIndex.content));
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const showDetail = () => {
    return (dispatch, getState) => {
        dispatch(createShowDetail(true));
    }
}
export const hideDetail = () => {
    return (dispatch, getState) => {
        dispatch(createHideDetail(false));
    }
}


export const pasteSubTask = (list, task) => {
  return async (dispatch, getState) => {
    try {
      let str = pasteSubTasksUrl + "?list=" + JSON.stringify(list);
      let result = await request(str, 'post', task);
    } catch (e) {
      console.log(e);
      message.error(e.message)
    } finally { }
  }
}

// 获取合作、地区列表
export const getAgentsAndAreas = () => {
  return async (dispatch, getState) => {
    try {
      let response = await request(partnerUrl.paramList);
      dispatch(createAgentsAction(response.partnerName));
      dispatch(createAreasAction(response.area));
    } catch (e) {
      throw new Error(e);
    }
  }
}

// 获取api的Url
export const getApiUrl = taskId => {
  return async (dispatch, getState) => {
    try {
      let response = await request(getApi + '?taskId=' + taskId);
      console.log(response);
      dispatch(createApiAction({url: response}));
    } catch (error) {
      throw new Error(e);
    }
  }
}


export const getList = (param) => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let url = getListUrl + paramsEncode(param).replace(/\&/, '?');
      let result = await request(url);
      let list = result.list;
      dispatch(createListAction(list));
      dispatch(createPageAction(result.total));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

// 获取主,次脚本
export const getPrimaryAndOtherScript = () => {
  return async (dispatch, getState) => {
    try {
      let response = await request(scriptUrl.paramList);
      dispatch(createPrimaryScriptAction(response.primary));
      dispatch(createOtherScriptAction(response.other));
    } catch (e) {
      throw new Error(e);
    }
  }
}

export const getProvinceList = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getProvinceUrl);
      dispatch(createProvinceListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const getMonitorList = () => {
  return async (dispatch, getState) => {
    try {
      //dispatch(createLoadingAction(true));
      let result = await request(getMonitorListUrl);
      dispatch(createMonitorListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      //dispatch(createLoadingAction(false));
    }
  }
}
export const getLabelList = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getLabelUrl);
      dispatch(createLabelListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const getCurveList = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getCurvelUrl);
      dispatch(createCurveListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const getClusterList = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getClusterUrl);
      dispatch(createClusterListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const getOutTaskCategoryList = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getOutTaskCategoryUrl);
      dispatch(createOutTaskCategoryListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const getGroupList = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getGroupsList);
      dispatch(createGroupListAction(result));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const getTaskId = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(createLoadingAction(true));
      let result = await request(getTaskIdUrl);
      let taskId = result.taskId;
      dispatch(createGetTaskIdAction(taskId))
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally {
      dispatch(createLoadingAction(false));
    }
  }
}

export const submitToMD = (parmas) => {
  return async (dispatch, getState) => {
    try {
      let result = await request(submitTaskUrl, 'post', parmas);
      dispatch(createAddShowAction(false));
      dispatch(createEditShowAction(false));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally { }
  }
}
export const insertToMD = (parmas) => {
  return async (dispatch, getState) => {
    try {
      let result = await request(insertTaskUrl, 'post', parmas);
      dispatch(createAddShowAction(false));
      dispatch(createEditShowAction(false));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally { }
  }
}
export const bulkToMD = (parmas) => {
  return async (dispatch, getState) => {
    try {
      let result = await request(bulkUpdateUrl, 'post', parmas);
      dispatch(createbulkUpdateShowTaskAction(false));
    } catch (e) {
      console.log(e);
      alert(e.message)
    } finally { }
  }
}
export const submitOpera = (id, type) => {
  return async (dispatch, getState) => {
    try {
      let str = operaTaskUrl + '?taskId=' + id + '&status=' + type;
      let result = await request(str, 'delete');
      return;
      console.log('tijiao', result)
    } catch (e) {
      console.log(e);
    } finally { }
  }
}

export const bunchOnoffTask = (ids, type) => {
  return async (dispatch, getState) => {
    try {
      //let str = bunchOnoffTaskUrl + '?' + paramsEncode(ids,'taskIds','utf-8') + '&status=' + type;
      let str = bunchOnoffTaskUrl + '?status=' + type;
      // console.log(str);
      // console.log(ids, JSON.stringify(ids));

      let result = await request(str, 'POST', ids);
    } catch (e) {
      console.log(e);
      message.error(e.message)
    } finally { }
  }
}

export const resetPv = (id, num) => {
  return async (dispatch, getState) => {
    try {
      let str = resetPvUrl + '?taskId=' + parseInt(id) + '&num=' + parseInt(num);
      let result = await request(str);
      dispatch(createResetPvShowAction(false));
      dispatch(createSetTaskIdAction(0));
    } catch (e) {
      console.log(e);
      message.error(e.message)
    } finally { }
  }
}
export const getPv = (id) => {
  return async (dispatch, getState) => {
    try {
      let str = getPvUrl + '?taskId=' + parseInt(id);
      let result = await request(str);
      dispatch(createGetPvAction(result));
    } catch (e) {
      console.log(e);
      message.error(e.message);
      throw new Error(e);
    } finally { }
  }
}

//获取用户列表流信息
export const getUserList = () => {
    let url = Urls.UserUrl.allList;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            const data=await request(url);
            dispatch(createUserListAction(data));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
};



// WEBPACK FOOTER //
// ./pages/task/tasklist/actions.js